import React, { useEffect, useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "../assets/css/EditCustomer.css";
import "../assets/css/DigixLeads.css";
import "../assets/css/AddSocialaccount.css";
import axiosInstance from "../components/api/axiosInstance";
import { SOCIAL_PLATFORMS } from "../constants/socialPlatforms";

const ACCOUNT_STATUSES = ["Active", "Inactive"];

function AddAccount({ onBack, onAddAccount, initialClientId = "" }) {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    platformName: "",
    accountName: "",
    username: "",
    password: "",
    profileUrl: "",
    businessUrl: "",
    emailUsed: "",
    contactNumber: "",
    clientId: initialClientId ? String(initialClientId) : "",
    status: "",
    notes: ""
  });

  useEffect(() => {
    if (initialClientId == null || initialClientId === "") return;
    setFormData((prev) => ({
      ...prev,
      clientId: String(initialClientId)
    }));
  }, [initialClientId]);

  const [submitting, setSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.platformName?.trim() || !formData.accountName?.trim() || !formData.username?.trim() || !formData.password?.trim()) {
      alert("Please fill in required fields (Platform Name, Account Name, Username, and Password)");
      return;
    }

    // Get Created_By from user
    let createdBy = 1;
    try {
      const userStr = localStorage.getItem("user");
      if (userStr) {
        const user = JSON.parse(userStr);
        createdBy = user.user_id || user.id || 1;
      }
    } catch (err) {
      console.error("Error reading user for Created_By:", err);
    }

    const payload = {
      Platform_Name: formData.platformName,
      Account_Name: formData.accountName,
      Username: formData.username,
      Password: formData.password?.trim() || "",
      Profile_URL: formData.profileUrl || null,
      Business_URL: formData.businessUrl || null,
      URL: (formData.businessUrl || formData.profileUrl || "").trim() || null,
      Email_Used: formData.emailUsed || null,
      Contact_Number: formData.contactNumber || null,
      client_id: formData.clientId ? Number(formData.clientId) : null,
      Status: formData.status || "Active",
      Notes: formData.notes || null,
      Created_By: createdBy
    };

    setSubmitting(true);
    try {
      const response = await axiosInstance.post('/create-social-account', payload);
      
      if (response.data) {
        alert("Account created successfully");
        if (onAddAccount) onAddAccount();
        if (onBack) onBack();
      } else {
        throw new Error("Create failed - no response data");
      }
    } catch (err) {
      console.error("Error creating account:", err);
      const msg =
        err.response?.data?.message ||
        err.response?.data?.error ||
        "Failed to create account.";
      alert(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="editcustomer-container">
      <div className="viewlead-header">
        <button
          type="button"
          className="viewlead-back-link"
          onClick={() => navigate(-1)}
        >
          <FaArrowLeft /> Back
        </button>
      </div>
      <form className="editcustomer-form" onSubmit={handleSubmit}>
        <div className="form-section">
          <div className="form-grid">
            <div className="form-group">
              <label>Platform Name <span className="required">*</span></label>
              <select
                name="platformName"
                value={formData.platformName}
                onChange={handleInputChange}
                required
              >
                <option value="">Select platform</option>
                {SOCIAL_PLATFORMS.map((p) => (
                  <option key={p.value} value={p.value}>
                    {p.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Account Name <span className="required">*</span></label>
              <input
                type="text"
                name="accountName"
                value={formData.accountName}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Username <span className="required">*</span></label>
              <input
                type="text"
                name="username"
                value={formData.username}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Password <span className="required">*</span></label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Profile URL</label>
              <input
                type="url"
                name="profileUrl"
                value={formData.profileUrl}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <label>Business URL</label>
              <input
                type="url"
                name="businessUrl"
                value={formData.businessUrl}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <label>Email Used</label>
              <input
                type="email"
                name="emailUsed"
                value={formData.emailUsed}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <label>Contact Number</label>
              <input
                type="text"
                name="contactNumber"
                value={formData.contactNumber}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <label>Status</label>
              <select
                name="status"
                value={formData.status}
                onChange={handleInputChange}
              >
                <option value="">Select Status</option>
                {ACCOUNT_STATUSES.map((status) => (
                  <option key={status} value={status}>
                    {status}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Notes</label>
              <textarea
                name="notes"
                value={formData.notes}
                onChange={handleInputChange}
                rows="3"
              />
            </div>
          </div>
        </div>

        <div className="editcustomer-actions">
          <button type="submit" className="addaccount-create-btn" disabled={submitting}>
            {submitting ? "Creating..." : "Create Account"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddAccount;
